export default __webpack_public_path__ + "static/media/not-found.06040954.svg";